<template>
  <div class="offers-list-page__empty offers-list-page-empty empty-offers">
    <div class="offers-list-page-empty__icon" />
    <div class="offers-list-page-empty__content">
      {{ trans('offer.list.empty') }}
    </div>
    <div class="offers-list-page-empty__actions">
      <a class="btn btn--primary" :href="goToCreateOfferPage()">
        {{ trans('office_offer.create') }}
      </a>
    </div>
  </div>
</template>

<script>
import translation from '@elements/translation';
import { URL_OFFER_CREATE } from '@tools/routes/routes';

export default {
  name: 'OfferCardEmpty',
  mixins: [ translation ],
  methods: {
    goToCreateOfferPage() {
      return URL_OFFER_CREATE;
    },
  },
};
</script>
